import React, { useEffect, useState, useRef } from "react";
import "../Style/Component/otpModal.css";
import { postWithTokenAPI } from "../Util/Api.js";
import { useSelector } from "react-redux";

const OtpModal = ({ open, onClose, phone, onOtpSuccess }) => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const adminId = auth.userId;

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [verifying, setVerifying] = useState(false);
  const inputsRef = useRef([]);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  // ✅ SEND OTP ON OPEN
  useEffect(() => {
    if (!open) return;

    setOtp(["", "", "", ""]);

    const sendOtp = async () => {
      try {
        const payload = {
          phoneNumber: phone,
          adminId: adminId,
        };

        const res = await postWithTokenAPI(token, "/admin/send-otp", payload);

        if (res?.statusCode === 200) {
          // SafeToast.success("OTP sent to your mobile number");
        } else {
          // SafeToast.error("Failed to send OTP");
        }
      } catch {
        // SafeToast.error("OTP service failed");
      }
    };

    sendOtp();
  }, [open]);

  // ✅ AUTO VERIFY WHEN 4 DIGITS FILLED
  useEffect(() => {
    const finalOtp = otp.join("");

    if (finalOtp.length !== 4 || verifying) return;

    const verifyOtp = async () => {
      try {
        setVerifying(true);

        const payload = {
          adminId: adminId,
          otp: finalOtp,
        };

        const res = await postWithTokenAPI(token, `/admin/verify-otp`, payload);

        if (res?.statusCode === 200) {
          onOtpSuccess(true);
          onClose();
        } else {
          // SafeToast.error("Invalid OTP");
          setOtp(["", "", "", ""]);
          inputsRef.current[0]?.focus();
        }
      } catch {
        // SafeToast.error("OTP verification failed");
        setOtp(["", "", "", ""]);
      } finally {
        setVerifying(false);
      }
    };

    verifyOtp();
  }, [otp]);

  // Input handler
  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  if (!open) return null;

  return (
    <div className="otp-backdrop" onClick={onClose}>
      <div className="otp-card" onClick={(e) => e.stopPropagation()}>
        <h3>Enter OTP</h3>

        <div className="otp-inputs">
          {otp.map((digit, i) => (
            <input
              key={i}
              ref={(el) => (inputsRef.current[i] = el)}
              type="text"
              maxLength="1"
              className="otp-box"
              value={digit}
              onChange={(e) => handleChange(e, i)}
            />
          ))}
        </div>

        <p className="otp-text">
          OTP sent to <br />
          <strong>{phone}</strong>
        </p>
      </div>
    </div>
  );
};

export default OtpModal;
